'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = 'M48 288l0-240 48 0 0 112 48 0 0-112 48 0 0 80 48 0 0-80 96 0 0 240-288 0zM0 384l128 0 0 128 128 0 0-128 128 0 0-384-384 0 0 384zm192 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;